import { render, staticRenderFns } from "./ProjectSecretFiles.vue?vue&type=template&id=abb3afa8&"
import script from "./ProjectSecretFiles.vue?vue&type=script&lang=js&"
export * from "./ProjectSecretFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports